<template>
  <span :id="renderItemId" style="cursor: pointer;" @click="updateNavigation">
    <slot />
    <!-- <h:commandLink action="#{documentElementBean.updateHeader}" class="#{renderItem.styleClass}">
      <h:outputText value="#{renderItem.content}" escape="false" />
      <f:setPropertyActionListener
        target="#{documentElementBean.selectedParent}"
        value="#{renderItem.parent}"
      />
      <f:setPropertyActionListener
        target="#{documentElementBean.selectedObject}"
        value="#{renderItem.object}"
      />
      <f:ajax render="@form" />
    </h:commandLink>-->
  </span>
</template>

<script>
export default {
  name: "RenderItem",
  props: ["navigation", "selectedObjectId"],
  computed: {
    selected() {
      return this.navigation &&
        this.selectedObjectId &&
        this.navigation.id == this.selectedObjectId
        ? true
        : false;
    },
    renderItemId() {
      if (this.navigation == undefined) {
        return undefined;
      }
      return `renderItem${this.navigation.id}`;
    }
  },
  methods: {
    updateNavigation() {
      this.$emit("updateNavigation", this.navigation);
    }
  }
};
</script>